import React, { useState, useEffect, useContext, useRef } from "react";
import { Tab, Tabs, Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
import axios from "axios";
import Cookies from 'universal-cookie';
import { withRouter, generatePath, useHistory, useParams } from "react-router-dom";
import {FormattedMessage, useIntl} from 'react-intl';
import Pagination from "./pagination";
import { RouteContext } from "../../contexts/route.context";
import { translateTerm } from "../../util/helper";
import { useIntersection } from "../../util/useIntersection";
import { QRCode } from 'react-qrcode-logo';
import renterLogo from '../../assets/images/qrlogonew.png';
import * as htmlToImage from 'html-to-image';

const ProfileQr = () => {
    const intl = useIntl();
    const { id } = useParams();
    const [trueDL, setTrueDL] = useState(true);
    const {getMe, me,} = useContext(RouteContext);

     const downloadQr = async () => {
        if(renterLogo){
            var node = document.getElementById('my-node');
            const result = await htmlToImage.toPng(node)
            const result2 = await htmlToImage.toPng(node)
            const result3 = await htmlToImage.toPng(node)
            .then(function (dataUrl) {
                // const url = window.URL.createObjectURL(new Blob([blob]));
                // const link = document.createElement("a");
                // link.href = url;
                
                // link.click();
                // console.log("Check")
              var img = new Image();
              img.src = dataUrl;
            //   document.body.appendChild(img);
              const link = document.createElement('a');
              link.href = dataUrl;
              link.download = `my-profile.png`;
              link.click();
              link.remove();
              setTrueDL(false)
            })
            .catch(function (error) {
              console.error('oops, something went wrong!', error);
            });
        }
    }

    const downloadCode = () => {
        downloadQr()
    }
    return(
        <div className="container">
            <div className="qr-container" >
                <div className="qr-box">
                    <div className="thisqr" id={"my-node"}>
                        <QRCode
                        size={300} 
                        // enableCORS={true}
                        ecLevel={"L"} logoImage={renterLogo} 
                        logoHeight={350*0.25} 
                        logoWidth={350*0.25} 
                        logoPaddingStyle={"circle"} 
                        qrStyle={"squares"} 
                        value={`https://www.renter.net/lessor-profile/${id}`} 
                        id={"largeqr"}
                        bgColor={"#ffffff"}
                        />
                        <p 
                        // className="thisqr-p"
                        style={{color: "black", marginTop: -40, fontSize: 30, right: 0, marginLeft: 10, textAlign: "left", padding: 0}}
                        >Renter.net</p>
                    </div>
                </div>
                
                <div className="displayqr">
                    <h3>Profile Details</h3>
                    <p><span>Name: </span>{me?.name}</p>
                    <p><span>Mobile: </span>{me?.phone}</p>
                    <p><span>Email: </span>{me?.email}</p>
                    <p><span>Address: </span>{me?.address}</p>
                </div>
            </div>
            <div className={"qrbuttons"}>
                <div className="downloadbutton" onClick={downloadCode}>
                    <p>
                        <FormattedMessage 
                            id="download.text"
                            defaultMessage="Download"
                            description="Download"
                        />
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ProfileQr;